import cn from "~/utils/cn";

export default function Logo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 144 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(
        "logo [&>path]:fill-text [&>path]:transition-colors [&>path]:duration-200",
        className,
      )}
    >
      <path
        d="M84.7095 111.851H72.3758L22.7699 36.6286V111.851H10.4362V17.247H22.7699L72.3758 92.3335V17.247H84.7095V111.851Z"
        fill="currentColor"
      />
      <path
        d="M123.614 111.851L84.7157 68.7504V111.851H72.382V17.3826H84.7157V61.1604L123.75 17.3826H139.336L96.5073 64.6843L139.743 111.851H123.614Z"
        fill="currentColor"
      />
      <path
        d="M7.75195 127.31L39.8814 127.221"
        stroke="#FAFF1A"
        strokeWidth="15.2312"
        strokeLinecap="round"
      />
      <path
        d="M39.8813 127.221L72.0108 127.132"
        stroke="#6DD3CE"
        strokeWidth="15.2312"
        strokeLinecap="round"
      />
      <path
        d="M72.0107 127.132L104.14 127.044"
        stroke="#3A0CA3"
        strokeWidth="15.2312"
        strokeLinecap="round"
      />
      <path
        d="M104.14 127.044L136.27 126.955"
        stroke="#F72585"
        strokeWidth="15.2312"
        strokeLinecap="round"
      />
    </svg>
  );
}
